import React from 'react';
import classnames from 'classnames';
import { AvatarProps } from '../../types.d';

import styles from '../../Avatar.module.scss';

function ModeratorHappy({
  size,
  className,
}: Pick<AvatarProps, 'size' | 'className'>): JSX.Element {
  return (
    <svg
      className={classnames(className, {
        [styles[size]]: size,
      })}
      x="0px"
      y="0px"
      viewBox="0 0 144 144"
      enableBackground="new 0 0 144 144"
      xmlSpace="preserve"
    >
      <g id="hécate">
        <g id="default_8_">
          <ellipse
            fill="#A6E3F9"
            cx="72"
            cy="72"
            rx="72"
            ry="72"
          />
          <g>
            <g>
              <defs>
                <circle
                  id="SVGID_1_"
                  cx="72"
                  cy="72"
                  r="72"
                />
              </defs>
              <clipPath id="SVGID_2_">
                <use
                  xlinkHref="#SVGID_1_"
                  overflow="visible"
                />
              </clipPath>
              <g clipPath="url(#SVGID_2_)">
                <rect
                  x="4.0737233"
                  y="102.0331802"
                  transform="matrix(0.5533891 -0.8329229 0.8329229 0.5533891 -82.9545898 53.8326683)"
                  fill="#00AFEC"
                  width="9.2951078"
                  height="4.4754238"
                />
                <rect
                  x="75.2756882"
                  y="-4.643106"
                  transform="matrix(0.8660254 -0.5 0.5 0.8660254 10.3825998 38.7572937)"
                  fill="#00AFEC"
                  width="4.4754233"
                  height="9.2951117"
                />
                <rect
                  x="117.2760086"
                  y="120.2489471"
                  transform="matrix(0.8124323 -0.5830555 0.5830555 0.8124323 -50.4046822 93.1096725)"
                  fill="#FFE502"
                  width="4.4754205"
                  height="9.2951136"
                />
                <rect
                  x="127.7464447"
                  y="54.6952744"
                  transform="matrix(0.8124323 -0.5830555 0.5830555 0.8124323 -10.2193375 86.9187698)"
                  fill="#FFE502"
                  width="4.4754205"
                  height="9.2951097"
                />
                <rect
                  x="9.403801"
                  y="64.8106537"
                  transform="matrix(0.4566261 -0.8896587 0.8896587 0.4566261 -52.0150185 48.933239)"
                  fill="#FFE502"
                  width="9.2951136"
                  height="4.4754243"
                />
                <rect
                  x="121.9771805"
                  y="73.2470551"
                  transform="matrix(0.7661693 -0.6426387 0.6426387 0.7661693 -21.0128403 98.0394516)"
                  fill="#00AFEC"
                  width="4.4754229"
                  height="9.2951078"
                />
                <rect
                  x="17.0192451"
                  y="17.9226513"
                  transform="matrix(0.5533891 -0.8329229 0.8329229 0.5533891 -7.1153984 27.0506115)"
                  fill="#FFE502"
                  width="9.2951107"
                  height="4.4754233"
                />
                <rect
                  x="92.8409805"
                  y="17.9226532"
                  transform="matrix(0.5533891 -0.8329229 0.8329229 0.5533891 26.7474155 90.2042694)"
                  fill="#FFE502"
                  width="9.2951107"
                  height="4.4754233"
                />
                <rect
                  x="4.5821404"
                  y="40.4021645"
                  transform="matrix(0.7661693 -0.6426387 0.6426387 0.7661693 -27.3560066 14.9167089)"
                  fill="#00AFEC"
                  width="4.4754233"
                  height="9.2951117"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <defs>
                <ellipse
                  id="SVGID_3_"
                  cx="72.0745621"
                  cy="72.0011215"
                  rx="71.9254379"
                  ry="71.996666"
                />
              </defs>
              <clipPath id="SVGID_4_">
                <use
                  xlinkHref="#SVGID_3_"
                  overflow="visible"
                />
              </clipPath>
              <g
                id="profil_13_"
                clipPath="url(#SVGID_4_)"
              >
                <g>
                  <g>
                    <g>
                      <path
                        fill="#0E0E11"
                        d="M74.366539,17.1516857l-5.7375717,0.3199902l5.624115,118.1082153l16.4723969-0.9187469 c14.272522-0.7959442,24.7258759-13.7722931,22.4785538-27.9035797l-5.66922-62.8315468 C104.971611,27.8085766,90.6449509,16.2437439,74.366539,17.1516857z"
                      />
                      <path
                        fill="#00AFEC"
                        d="M84.0493317,109.1711655c-6.1968002,4.0747604-7.9205246,12.4066391-3.8500519,18.6102676 c0.3260117,0.4967957,0.6884003,0.9539337,1.0654297,1.3925934l-0.0109787,0.0081329l35.0262146,41.1755829 l17.4774857-9.9149475l-31.1165848-47.4181213C98.5702362,106.8215485,90.2463608,105.0959244,84.0493317,109.1711655z"
                      />
                      <ellipse
                        fill="#00AFEC"
                        cx="91.0446548"
                        cy="120.5551147"
                        rx="13.8107634"
                        ry="13.8248682"
                      />
                      <path
                        fill="#00AFEC"
                        d="M104.7803726,121.1943054l-3.5751801,77.3355713H51.8030205l-20.4152851-81.2158966 c-1.350481-5.3726578,2.7074413-10.5836868,8.2420521-10.5836868H90.984375 C98.8624573,106.7302933,105.1445541,113.3165741,104.7803726,121.1943054z"
                      />
                      <path
                        fill="#00AFEC"
                        d="M49.3688622,110.2932358c-5.6614571-5.116272-14.3943253-4.6697311-19.5058994,0.9975128 c-0.4093304,0.4538803-0.7697906,0.9337082-1.1080494,1.4233246l-0.0109425-0.0088272l-33.1594315,47.9997406 l15.711339,12.435791l39.070015-43.3216248C55.4769363,124.1519241,55.0308533,115.4096069,49.3688622,110.2932358z"
                      />
                      <path
                        fill="#283042"
                        d="M107.0445786,58.0859604c-0.0114746,0.0092049-0.0114746,0.0092049-0.0114746,0.0092049"
                      />
                      <path
                        fill="#D8A966"
                        d="M60.7674179,108.590004c1.0403748,6.3761368,7.0473099,10.7006683,13.4169464,9.6592331 c6.3696289-1.0414429,10.689743-7.0546265,9.6493759-13.4307632 c-1.0403824-6.3761292-7.0474319-10.7006607-13.4169464-9.6592255 C64.0471573,96.2006912,59.7269363,102.2138672,60.7674179,108.590004z"
                      />
                      <polygon
                        fill="#D8A966"
                        points="83.8337402,104.8184738 60.7674179,108.590004 56.1280632,80.1579971 56.8047905,80.047348
                        79.1944885,76.3865662"
                      />
                      <path
                        fill="#D8A966"
                        d="M70.805603,28.5482616l-1.7941208,0.2934055 C57.5612907,30.713768,49.7952843,41.5231171,51.6655807,52.98489l6.3790894,39.0943947l21.7170029-3.5508652 c10.9063644-1.7833023,18.3035126-12.079216,16.5220337-22.9966125l-3.4465332-21.1224861 C91.1287842,33.9393196,81.2648163,26.8381252,70.805603,28.5482616z"
                      />
                      <path
                        fill="#FFFFFF"
                        d="M75.6012344,73.7463303c0.360817,3.2101669,3.253006,5.519722,6.4598846,5.1585388 c3.2068939-0.3611755,5.5140915-3.2563171,5.1532745-6.4664841L75.6012344,73.7463303z"
                      />
                      <line
                        fill="none"
                        stroke="#0E0E11"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        x1="83.8821182"
                        y1="54.3658142"
                        x2="89.4867935"
                        y2="53.9395256"
                      />
                      <line
                        fill="none"
                        stroke="#0E0E11"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        x1="69.3953018"
                        y1="54.9877777"
                        x2="75.4790726"
                        y2="54.6183128"
                      />
                      <path
                        fill="#FDC9A3"
                        d="M52.3234825,68.7100906l4.76754-0.7760239L56.31847,63.1714706 c-0.426651-2.6302605-2.9070892-4.4150658-5.5400734-3.986496l0,0 c-2.6330681,0.4285812-4.4216347,2.9083633-3.9948997,5.5386047l0,0 C47.2101669,67.3539124,49.6905212,69.1387405,52.3234825,68.7100906z"
                      />
                      <ellipse
                        transform="matrix(0.998464 -0.0554047 0.0554047 0.998464 -3.2480879 4.1191511)"
                        fill="#0E0E11"
                        cx="72.6654968"
                        cy="60.6393547"
                        rx="1.5841323"
                        ry="2.0462916"
                      />
                      <ellipse
                        transform="matrix(0.998464 -0.0554047 0.0554047 0.998464 -3.1849387 4.8742824)"
                        fill="#0E0E11"
                        cx="86.315979"
                        cy="59.8780136"
                        rx="1.5841323"
                        ry="2.0462916"
                      />
                      <path
                        fill="#0E0E11"
                        d="M60.4639244,106.7300568l-20.834137,0.0002365l-1.1125183-59.4934464 c1.0204735-16.0828209,13.8884315-28.8641205,29.9622307-29.7606792l0,0 c0.826416-0.0460815,1.5453873,0.5608749,1.639473,1.3840485l1.8380432,16.0812588 c0.0043716,0.0381927,0.0075607,0.0750122,0.0096054,0.1133995 c0.3179016,5.9758492-1.9945068,15.9861412-4.8232346,21.2803802 c-0.0334091,0.0625381-5.418972,8.7930641-5.418972,8.7930641c-1.4366837,2.0509567-2.3696404,4.416893-2.6635246,6.9044952 C57.3645554,86.3916397,60.4639244,106.7300568,60.4639244,106.7300568z"
                      />
                      <path
                        fill="#0E0E11"
                        d="M65.4169388,27.9839077l11.9735947,11.9212132 c4.291626,4.2727928,10.2733154,6.3905144,16.2942734,5.7686882l0,0l1.1269608,10.9347458l-1.7625732-17.1017036 c-0.8097534-7.8563995-7.8285446-13.5682507-15.6769257-12.7576675L65.4169388,27.9839077z"
                      />
                    </g>
                  </g>
                </g>
                <g>
                  <polygon
                    fill="#00AFEC"
                    points="131.7313843,169.8096008 161.508728,125.2917328 151.1562805,117.585228 115.5834122,157.4307556"
                  />
                </g>
              </g>
            </g>
          </g>
          <path
            fill="#FFE500"
            d="M48.6829681,39.9588928c-0.2673874-1.0705948-1.1800232-32.1361465-1.1800232-32.1361465 l19.3811493,26.2478733L48.6829681,39.9588928z"
          />
        </g>
      </g>
    </svg>
  );
}

export default ModeratorHappy;
